import { useState, useEffect } from 'react';
import AppLayout from '@/components/feature/AppLayout';
import { useAuth } from '@/context/AuthContext';

export default function SWSubmitPage() {
  const { user } = useAuth();
  const [submitForm, setSubmitForm] = useState({ caseNumber: '', type: 'intervention_plan', description: '', amount: '' });
  const [submitted, setSubmitted] = useState(false);
  const [cases, setCases] = useState<any[]>([]);
  const [submittedCases, setSubmittedCases] = useState<any[]>([]);

  useEffect(() => {
    fetch(`https://guardiancloudcare.com/backend/api/get_children.php?uid=${user?.uid}`)
    .then(async (res) => {

      const text = await res.text();

      console.log(text);

      return JSON.parse(text);

    })
    .then(data => {

      if (Array.isArray(data)) {
        setCases(data);
      } else {
        setCases([]);
      }

    })
    .catch(err => {
      console.error(err);
      setCases([]);
    });

    fetch(`https://guardiancloudcare.com/backend/api/get_submitted_cases.php?uid=${user?.uid}`)
    .then(res => res.json())
    .then(data => {

      if (Array.isArray(data)) {
        setSubmittedCases(data);
      } else {
        setSubmittedCases([]);
      }

    })
    .catch(err => {
      console.error(err);
      setSubmittedCases([]);
    });
  }, []);

  const handleSubmit = async () => {
    if (!submitForm.caseNumber || !submitForm.description) return;

    await fetch("https://guardiancloudcare.com/backend/api/submit_case.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        case_number: submitForm.caseNumber,
        request_type: submitForm.type,
        request_type_description: submitForm.description,
        amount_requested:
          submitForm.type === 'financial_assistance'
            ? submitForm.amount
            : null,

        uid: user?.uid
      })
    });

    setSubmitted(true);

    setTimeout(() => {
      setSubmitted(false);
      setSubmitForm({
        caseNumber: '',
        type: 'intervention_plan',
        description: '',
        amount: ''
      });
    }, 3000);
  };

  return (
    <AppLayout title="Submit for Approval" breadcrumb={['Social Worker', 'Submit for Approval']}>
      <div className="w-full max-w-6xl mx-auto">
        <div className="bg-white rounded-xl border border-gray-100 p-6">
          <h3 className="font-semibold text-gray-800 mb-1">Submit for Supervisor Approval</h3>
          <p className="text-sm text-gray-500 mb-5">Submit intervention plans, financial assistance requests, or case closure for supervisor review.</p>
          {submitted ? (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4"><i className="ri-checkbox-circle-line text-teal-500 text-3xl" /></div>
              <p className="font-semibold text-gray-800">Submitted Successfully!</p>
              <p className="text-sm text-gray-500 mt-1">Your request has been sent to the supervisor for review.</p>
            </div>
          ) : (
            <div className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-1.5 block">Case Number 
                      <span className="text-red-500">*</span></label>
                  <select value={submitForm.caseNumber} onChange={(e) => setSubmitForm({ ...submitForm, caseNumber: e.target.value })} className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-teal-500 cursor-pointer">
                    <option value="">Select case...</option>
                    {cases.map((c) => (
                      <option key={c.case_number} value={c.case_number}>
                        {c.case_number} — {c.full_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-1.5 block">Request Type 
                     <span className="text-red-500">*</span></label>
                  <select value={submitForm.type} onChange={(e) => setSubmitForm({ ...submitForm, type: e.target.value })} className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-teal-500 cursor-pointer">
                    <option value="intervention_plan">Intervention Plan</option>
                    <option value="financial_assistance">Financial Assistance</option>
                    <option value="case_closure">Case Closure</option>
                    <option value="escalation">Escalation Request</option>
                  </select>
                </div>
              </div>

              {submitForm.type === 'financial_assistance' && (
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-1.5 block">Amount Requested (₱)</label>
                  <input type="number" value={submitForm.amount} onChange={(e) => setSubmitForm({ ...submitForm, amount: e.target.value })} placeholder="0.00" className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-teal-500" />
                </div>
              )}

              <div>
                <label className="text-sm font-medium text-gray-700 mb-1.5 block">Description / Justification <span className="text-red-500">*</span></label>
                <textarea value={submitForm.description} onChange={(e) => setSubmitForm({ ...submitForm, description: e.target.value })} rows={5} maxLength={500} placeholder="Describe the intervention plan, reason for financial assistance, or justification for case closure..." className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-teal-500 resize-none" />
                <p className="text-xs text-gray-400 text-right mt-1">{submitForm.description.length}/500</p>
              </div>
              <div className="bg-amber-50 border border-amber-200 rounded-xl p-3">
                <p className="text-xs text-amber-700"><i className="ri-information-line mr-1" />Once submitted, the supervisor will review and approve or reject this request. You will be notified of the decision.</p>
                 
              </div>
              <button onClick={handleSubmit} disabled={
                  !submitForm.caseNumber ||
                  !submitForm.description ||
                  (submitForm.type === 'financial_assistance' && !submitForm.amount)
                } className="bg-teal-500 text-white text-sm px-6 py-2.5 rounded-xl hover:bg-teal-600 disabled:bg-teal-300 cursor-pointer whitespace-nowrap flex items-center gap-2">
                <i className="ri-send-plane-line" />Submit for Approval
              </button>
            </div>
          )}
          <div className="mt-6 bg-white rounded-xl border border-gray-100 overflow-hidden">
            <div className="px-5 py-4 border-b border-gray-100">
              <h3 className="font-semibold text-gray-800">
                My Submitted Requests
              </h3>
            </div>

            <div className="divide-y divide-gray-50">

              {submittedCases.map((item) => (
                <div
                  key={item.id}
                  className="p-5"
                >

                  <div className="flex items-start justify-between gap-4">

                    <div>

                      <p className="text-sm font-semibold text-gray-800">
                        {item.case_number}s
                      </p>

                      <p className="text-sm text-gray-600">
                        {item.child_name}
                      </p>

                      <p className="text-xs text-gray-500 mt-1 capitalize">
                        {(item.request_type || 'No Type')
                          .replace(/_/g, ' ')}
                      </p>

                      <p className="text-xs text-gray-400 mt-1">
                        {item.request_type_description}
                      </p>

                      {item.amount && (
                        <p className="text-xs text-teal-600 mt-1">
                          ₱{item.amount_requested}
                        </p>
                      )}

                    </div>

                    <div className="text-right">

                      <span
                        className={`text-xs px-3 py-1 rounded-full capitalize ${
                          item.status === 'approved'
                            ? 'bg-green-100 text-green-700'
                            : item.status === 'rejected'
                            ? 'bg-red-100 text-red-700'
                            : 'bg-amber-100 text-amber-700'
                        }`}
                      >
                        {item.status}
                      </span>

                      <p className="text-xs text-gray-400 mt-2">
                        {item.submitted_at}
                      </p>

                    </div>

                  </div>

                </div>

              ))}

              {submittedCases.length === 0 && (

                <div className="text-center py-10 text-gray-400">
                  No submitted requests found
                </div>

              )}

            </div>

          </div>
        </div>
      </div>
    </AppLayout>
  );
}
